import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { insFundSeriesListStateId } from "components/pages/fund-series/fundSeriesList";
import { bulkDeleteFundSeries } from "components/pages/fund-series/api";
import { language } from "language/default";
import { setSelectedRowsState } from "store/grids";
import { closeDialog } from "store/messages-dialog";
import { requestAsync } from "redux-query";
export const InsDeleteFundSeriesDialogAction = () => {
    const dispatch = useDispatch();
    const selectedRows = useSelector((state) => state.grids.state[insFundSeriesListStateId]?.selectedRows, isEqual) ?? [];
    const handleDelete = () => {
        if (!selectedRows.length) {
            return;
        }
        batch(() => {
            dispatch(requestAsync(bulkDeleteFundSeries({ ids: selectedRows }, {
                meta: {
                    errorMessage: language.en.fundSeries.fundSeriesDeletion.deleteFundSeriesErrorMessage,
                    pendingMessage: language.en.fundSeries.fundSeriesDeletion.deleteFundSeriesPendingMessage,
                    successMessage: language.en.fundSeries.fundSeriesDeletion.deleteFundSeriesSuccessMessage
                }
            })));
            dispatch(setSelectedRowsState({
                id: insFundSeriesListStateId,
                selectedRows: []
            }));
            dispatch(closeDialog());
        });
    };
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "fund-series-main-delete-button", type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: handleDelete }),
        React.createElement(CloseDialogButton, null));
};
